module.exports = __webpack_public_path__ + "img/art_culture.a600d0e6.png";